import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
/** @jsx jsx */

import { jsx, Box, Flex, useColorMode } from 'theme-ui';
import { useConfig, useCurrentDoc } from 'docz';
import * as styles from './styles';
import { Edit, Menu, Sun, Github } from '../Icons';
import { Logo } from '../Logo';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Header = function Header(props) {
  var onOpen = props.onOpen;

  var _useConfig = useConfig(),
      repository = _useConfig.repository,
      _useConfig$themeConfi = _useConfig.themeConfig,
      showDarkModeSwitch = _useConfig$themeConfi.showDarkModeSwitch,
      showMarkdownEditButton = _useConfig$themeConfi.showMarkdownEditButton;

  var _useCurrentDoc = useCurrentDoc(),
      _useCurrentDoc$edit = _useCurrentDoc.edit,
      edit = _useCurrentDoc$edit === void 0 ? true : _useCurrentDoc$edit,
      doc = _objectWithoutPropertiesLoose(_useCurrentDoc, ["edit"]);

  var _useColorMode = useColorMode(),
      colorMode = _useColorMode[0],
      setColorMode = _useColorMode[1];

  var toggleColorMode = function toggleColorMode() {
    setColorMode(colorMode === 'light' ? 'dark' : 'light');
  };

  return jsx("div", {
    sx: styles.wrapper,
    "data-testid": "header"
  }, jsx(Box, {
    sx: styles.menuIcon
  }, jsx("button", {
    sx: styles.menuButton,
    onClick: onOpen
  }, jsx(Menu, {
    size: 25
  }))), jsx("div", {
    sx: styles.innerContainer
  }, jsx(Logo, null), jsx(Flex, null, repository && jsx(Box, {
    sx: {
      mr: 2
    }
  }, jsx("a", {
    href: repository,
    sx: styles.headerButton,
    target: "_blank",
    rel: "noopener noreferrer"
  }, jsx(Github, {
    size: 15
  }))), showDarkModeSwitch && jsx("button", {
    sx: styles.headerButton,
    onClick: toggleColorMode,
    "aria-label": "Switch to " + colorMode + " mode"
  }, jsx(Sun, {
    size: 15
  }))), showMarkdownEditButton && edit && doc.link && jsx("a", {
    sx: styles.editButton,
    href: doc.link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, jsx(Edit, {
    width: 14
  }), jsx(Box, {
    sx: {
      pl: 2
    }
  }, "Edit page"))));
};

if (typeof Header !== 'undefined' && Header && Header === Object(Header) && Object.isExtensible(Header) && !Header.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Header, '__filemeta', {
    configurable: true,
    value: {
      name: "Header",
      filename: "node_modules/gatsby-theme-docz/src/components/Header/index.js"
    }
  });
}